




















































































































import { Component, Prop } from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { Tabs, LongTextWings } from 'wings-ui-components';
import TemplatesFilter from '@/components/Templates/TemplatesFilter.vue';
import { TemplateItem } from "@/store/templates/types";
import { MsgTransports } from '@/store/types';
import {dateFilter} from "@/utils/date-util";
import {transformTransport} from "@/utils/download-helper";

@Component({components: {Tabs, TemplatesFilter,LongTextWings}, filters: {dateFilter}, methods: {transformTransport}})
export default class Templates extends BaseItemsPage<TemplateItem> {
  @Prop() transport!: MsgTransports;
  @Getter("templates") templateResponse: any;
  @Getter("moderationSettings") moderationSettings: any;

  private is_show_filter = false;
  private emailTransport: MsgTransports = MsgTransports.EMAIL;
  private mnTransport: MsgTransports = MsgTransports.MAILNOTIFY;
  private telegramOtpTransport: MsgTransports = MsgTransports.TELEGRAM_OTP;

  currentSort= "templateId";
  currentSortOrder= "desc";

  tableFields = [
    'templateId',
    'name',
    'author',
    'message',
    'routes',
    'vkMessage',
    'okMessage',
    'subject',
    'status',
    'description',
    'editDate',
  ];

  getData(): any {
    return this.templateResponse;
  }

  get moderation() {
    return this.moderationSettings.find((item: any) => item.transportName == this.transport)?.status === 1
  }

  toggleDraft(template: any) {
    const item: any = this.templateResponse.find((orig: any) => orig.templateId == template.templateId)
    item.showDraft = !item.showDraft
  }
}
